import { Injectable, Signal } from '@angular/core';

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class HeaderStateService {
  #isBackBtnPresent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false,
  );
  #backBtnClickEmmit$: Subject<void> = new Subject<void>();

  backBtnPresent: Signal<boolean> = toSignal(this.#isBackBtnPresent$, {
    initialValue: false,
  });

  public onBackBtnClick(): void {
    this.#backBtnClickEmmit$.next();
  }

  public set isBackBtnPresent(state: boolean) {
    this.#isBackBtnPresent$.next(state);
  }

  public get backBtnClickEmmit(): Observable<void> {
    return this.#backBtnClickEmmit$.asObservable();
  }
}
